import React from "react";
import { Button, Label, Modal, Table } from "semantic-ui-react";
import { socket } from "../../../lib/socketio";
import { getTimestamp } from "../../../lib/time";
import { useSelector } from "react-redux";

function ActiveEvents({ currentPLC }) {
  // update SOFC 240403 by sumin, get currentPLC data from EventHistory.js

  const [tableData, setTableData] = React.useState([]);
  const timezone = useSelector((state) => state.nav.timezone);
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
    fetchEvents();
  };
  const handleClose = () => {
    setOpen(false);
  };

  const fetchEvents = () => {
    var eventdata = { buttonClickType: "Get Active Events" };
    socket.emit("button click", eventdata);
    socket.on("receive active events", (data) => {
      setTableData(data.result);
    });
  };

  React.useEffect(() => {
    fetchEvents();
    return () => {
      socket.removeAllListeners();
    };
  }, []);

  // update SOFC 240403 by sumin, add condition - display each PSM's event log
  const renderBodyRow = (data, index) =>
    data.alarm_name.startsWith(currentPLC)
      ? {
          key: index,
          cells: [
            {
              key: "event_time",
              content: getTimestamp(
                data.datetime,
                timezone,
                data.flag_event_time_ambiguous,
              ),
            },
            {
              key: "event",
              content: parseEventCell(data),
              style: styles.event,
            },
            {
              key: "active",
              content:
                data.active === true
                  ? parseActiveCell("Active")
                  : parseActiveCell("Inactive"),
            },
          ],
        }
      : "";

  return (
    <div>
      <Modal
        trigger={<Button color="blue">Current Active Events</Button>}
        style={styles.toggle}
        open={open}
        onClose={handleClose}
        onOpen={handleOpen}
      >
        <Modal.Header>CURRENT ACTIVE EVENTS</Modal.Header>
        <Modal.Content>
          <div style={styles.defaults}>
            <Table
              unstackable
              compact
              headerRow={POWERPLANT_ALARM_TABLE_HEADER_ROW}
              tableData={tableData}
              renderBodyRow={renderBodyRow}
            />
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button
            color={"green"}
            size="small"
            id="1"
            content="Refresh"
            onClick={fetchEvents}
          />
          <Button
            color={"red"}
            size="small"
            id="2"
            content="Exit"
            onClick={handleClose}
          />
        </Modal.Actions>
      </Modal>
    </div>
  );
}

const styles = {
  event: {
    padding: "0",
  },
  defaults: {
    alignItems: "center",
    height: "300px",
    overflow: "auto",
  },
};

const POWERPLANT_ALARM_TABLE_HEADER_ROW = [
  { key: "date", content: "Date", width: 6 },
  { key: "event", content: "Event", width: 6 },
  { key: "active", content: "Current Status", width: 3 },
];

const parseEventCell = ({ level_id, alarm_name }) =>
  // <div>
  //     {alarm_name}
  // </div>
  alarm_name.includes("_SD_") ? (
    <div style={{ color: "red" }}> {alarm_name}</div>
  ) : (
    <div> {alarm_name} </div>
  );

const parseActiveCell = (active) => (
  <div>
    <Label
      horizontal
      size="medium"
      content={active}
      color={active === "Active" ? "green" : "gray"}
    />
  </div>
);

export default ActiveEvents;
